// extracted by mini-css-extract-plugin
export default {"container":"Tooltip_container__hZtlo","icon":"Tooltip_icon__N319+","triangle":"Tooltip_triangle__HJgLP","text":"Tooltip_text__FuL4K"};